import dayjs from '@services/date/index'

export default {
  methods: {
    displayDate(dateData) {
      if (dateData === null) {
        return ''
      }

      const convertDate = dayjs(dateData).format(
        this.$t('date.dateShortdatefFormat')
      )
      return convertDate
    },
  },
}
